import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurSpecializedExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-specialized-expertise" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-40 flex flex-col items-center justify-center min-h-[60vh]">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-[0.03] bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_60%_at_50%_50%,#000_70%,transparent_100%)]" />

      {}
      <div className="absolute inset-0 z-0 bg-[radial-gradient(circle_at_center,var(--primary)_0%,transparent_45%)] opacity-10 blur-3xl" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="mb-8 flex justify-center">
          <div className="h-px w-16 bg-primary/50" />
        </div>

        <h1 className="font-serif text-4xl md:text-5xl lg:text-7xl font-medium tracking-tight mb-6 text-foreground">
          Strategic Wealth Architecture
        </h1>

        <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-10">
          We engineer sophisticated financial frameworks for high-net-worth
          individuals. Our technical expertise in advanced tax-strategy
          consulting and private life insurance solutions builds a resilient
          foundation for your legacy.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="min-w-[160px]">
            <Link to="/WealthArchitecturePage">Explore Our Framework</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="min-w-[160px] border-primary/20 hover:bg-primary/10 hover:text-primary">
            <Link to="/contact">Consult an Advisor</Link>
          </Button>
        </div>

        {}
        <div className="mt-16 animate-bounce opacity-50">
          <ArrowDown className="w-6 h-6 mx-auto text-primary" />
        </div>
      </div>
    </section>;
}